export enum EdgeBehaviorType {
  ELEVATION_NOTE = "ELEVATION_NOTE",
  WALL_ASSEMBLY = "WALL_ASSEMBLY",
  DIMENSION = "DIMENSION",
  TRIM = "TRIM",
  PORCH_COLUMN = "PORCH_COLUMN",
  FOUNDATION_ASSEMBLY = "FOUNDATION_ASSEMBLY",
  FOUNDATION_PATTERN = "FOUNDATION_PATTERN",
  LABEL = "LABEL",
}
